import { cacheTypes, getMethodByCallBack, serverUrl, setErrorDialog, getheader, postMethodByCallBack } from "../../../store/api/CommonFunctions";
export function deleteUser(userID, fn) {
    return dispatch => {
        fetch(serverUrl + "api/UserAPI/DeleteUser", {
            headers: getheader(),
            body: userID,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "حذف کاربر");
                    return;
                }
                setErrorDialog(dispatch, "success", "حذف کاربر");
                if (fn) {
                    fn();
                }
            }).then(e => console.log("[DeleteUser]", e));
    }
}
export function addOrUpdateUser(data, fn) {
    postMethodByCallBack("api/UserAPI/AddOrUpdateUser", data, fn, "AddOrUpdateUser");
}
export function getUserList(name) {
    return dispatch => {
        dispatch({
            type: "GET_USER_LIST",
            data: "PENDING"
        });
        if (!name) {
            name = "";
        }
        fetch(serverUrl + "api/UserAPI/SearchUser?Name=" + name, {
            headers: getheader(),
            method: "GET"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "GET_USER_LIST",
                    data: res
                });
            })
    }
}
export function getUserList4Modal(name, onGetData, filterOnCurrentUser = false) {
    onGetData("PENDING");
    if (!name) {
        name = "";
    }
    fetch(serverUrl + `api/UserAPI/SearchUser?Name=${name}&stageID=${null}&filterOnCurrentUser=${filterOnCurrentUser}`, {
        headers: getheader(),
        method: "GET"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = null;
            }
            onGetData(res);
        })
}
export function searchUser(data) {
    return dispatch => {
        dispatch({
            type: "GET_USER_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/UserAPI/GetUsers", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "جستجوی کاربران");
                    res = null;
                }
                return dispatch({
                    type: "GET_USER_LIST",
                    data: res
                });
            })
    }
}
export function copyUserPermission(fromUserID, toUserID, onCopyDone) {
    getMethodByCallBack(`api/UserAPI/CopyPermission?fromUserID=${fromUserID}&toUserID=${toUserID}`, cacheTypes.NoCache, onCopyDone, "CopyPermision");
}
export function setUserPop(status) {
    return dispatch => {
        return dispatch({
            type: "USER_POP",
            data: status
        });
    }
}
export function setSelectedUserPop(status) {
    return dispatch => {
        return dispatch({
            type: "SELECTED_USER_POP",
            data: status
        });
    }
}
export function setReferDocPop(status) {
    return dispatch => {
        return dispatch({
            type: "REFERDOC_POP",
            data: status
        });
    }
}
export function referDocument(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/UserDashboardAPI/ReferDocument", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data),
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ارجاع به کاربر");
                    return;
                }
                setErrorDialog(dispatch, "success", "ارجاع به کاربر");
                if (fn) {
                    fn();
                }
            })
    }
}
export function getUserRoleList() {
    return dispatch => {
        dispatch({
            type: "USER_ROLES",
            data: "PENDING"
        });
        fetch(serverUrl + "api/UserAPI/GetUserRoleList", {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                dispatch({
                    type: "USER_ROLES",
                    data: res
                });
            }).catch(e => console.log("[USER_ROLES]", e));
    }
}
export function selectPageNode(parentName, userID, fn) {
    fetch(serverUrl + `api/UserAPI/SelectPageNode?parentName=${parentName}&userID=${userID}`, {
        method: "GET",
        headers: getheader()
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = [];
            }
            if (fn) {
                fn(res);
            }
        })
}
export function grantOrRemovePermission(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/UserAPI/GrantOrRemovePermission", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت دسترسی کاربر");
                    return;
                }
                setErrorDialog(dispatch, "success", "ثبت دسترسی کاربر");
                if (fn) {
                    fn(res);
                }
            }).catch(e => console.log("[UPDATE_PAGE_PERMISSION]", e));
    }
}
export function findPagePath(name, fn) {
    getMethodByCallBack(`api/UserAPI/FindPagePath?searchingName=${name}`, cacheTypes.NoCache, fn, "FIND_PAGE_PATH");
}
export function GrantFullPermission(userID, fn) {
    return dispatch => {
        fetch(serverUrl + "api/UserAPI/GrantFullPermission", {
            headers: getheader(),
            body: userID,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت دسترسی کاربر");
                    return;
                }
                setErrorDialog(dispatch, "success", "ثبت دسترسی کاربر");
                if (fn) {
                    fn(res);
                }
            }).catch(e => console.log("[GrantFullPermission]", e));
    }
}
export function getPageFieldList(pageID, userID, fn) {
    fetch(serverUrl + `api/UserAPI/GetPageFieldList?pageID=${pageID}&userID=${userID}`, {
        method: "GET",
        headers: getheader()
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = [];
            }
            if (fn) {
                fn(res);
            }
        })
}
export function getPageFieldListByName(pageName) {
    return dispatch => {
        fetch(serverUrl + `api/AccountAPI/GetPageFieldList?pageName=${pageName}`, {
            method: "GET",
            headers: getheader()
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = [];
                }
                dispatch({
                    type: "PAGE_FIELD_LIST",
                    data: res
                })
            })
    }
}
export function logOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("SystemID");
    localStorage.removeItem('RoleList');
    localStorage.removeItem('UserInfo');
    localStorage.removeItem('now');
    localStorage.removeItem("DurationID");
    localStorage.removeItem("DurationName");
}
export function getUserMenuList(userID, onGet) {
    getMethodByCallBack(`api/UserAPI/GetUserMenuList?userID=${userID}`, cacheTypes.NoCache, onGet, "GetUserMenuList");
}
export function updateUserMenuAccessNumber(userID, accessList, onUpdate) {
    postMethodByCallBack(`api/UserAPI/UpdateUserMenuAccessNumber?userID=${userID}`, accessList, onUpdate, "UpdateUserMenuAccessNumber");
}